import React, {useEffect}  from "react";
import { connect } from "react-redux";
// import './split1.css';
import { searchPropOverviews } from "../../../actions/propOverviewAction";
// import {
//   Image,
//   //Button,
// } from "semantic-ui-react";
import{ imageDomain} from "../../configC/keys"
import Loading from "../../common/Loading";
  
  
   const LandingDwarka =(props)=>{

    useEffect(() => {
      props.searchPropOverviews() ;
 window.scroll(0,0)
    //  //Cleanup function to clear the timer when the component unmounts
    //  return () => {
    //    clearTimeout(timerfn);
    //  };
   }, []);
      //*************** */
  const renderList = (overviews) => {
    const { heading,line1, line2, line3, line4, line5, line6, line7,tag,img, _id } = overviews;

    
    return (
      <div key={_id} className="dwkcard-overview bgColor-gr1 direction-c"
        
      >
        
        <div className="dwkcontent-ov-container">
        
        <div className="dwkcontent-ov"> 
        <span className="dwkribbon-ov">{tag}</span>
          <div  className="heading">{heading}  </div>
          {line1 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line1}</span>
              </div>
            )}
            {line2 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line2}</span>
              </div>
            )}
            {line3 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line3}</span>
              </div>
            )}
            {line4 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line4}</span>
              </div>
            )}
            {line5 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line5}</span>
              </div>
            )}
            {line6 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line6}</span>
              </div>
            )}
            {line7 && (
              <div className="list">
                <span className="list-ov">
                  <img
                    src="/bulletIcon_2.png"
                    alt=" "
                    style={{ width: "", height: "", verticalAlign: "" }}
                  />
                </span>
                <span>{line7}</span>
              </div>
            )}
         
         </div>
        
        </div>
        {/* img */}
        <div className="dwkimg-ov-container">
          
        <img className="dwkimg-ov" src={`${imageDomain}${img}`}  />
        </div>

      </div>
            
    );
  };
    //*************** */
   
    return (
      
      
      <section className="padding-gr-outer bgColor-gr1 ">
      
      <div className="inner-gr bgColor-gr1 ">
        {/* heading */}
        <div className="headtitl">
          <div
            className="mb-20 line-height-gr font-36B color-CornflowerBlue"
          >
          Overview of
 				<span> Properties for Sale & Rent in Dwarka Expressway (Gurugram)</span>
          </div>
          
          <div className="devider">
           
          </div>
        </div>
{/* end heading */}
        {/*Overview of Property for SALE/RENT section start */}
        
        <div 
        
        
        // style={{textAlign:'center' }} 
        >
        <div className="flex-center"
        // style={{justifyContent:'flex-start'}}
        >
          {/* {props.state.propOverviews.propOverviews.length ===0 &&
          <Loading/>
          } */}
        {props.state.propOverviews.propOverviews
        .filter((data) => data.city === 'Gurugram')
        .map((item)=> renderList(item))}
         
        </div>
        </div>
        
      </div>
   
</section>


   
    );
  }



const mapStateToProps = (state) => {
 
  return {
    state,
  };
};

export default connect(
  mapStateToProps,
 {searchPropOverviews}
  )(LandingDwarka);
  

